<template>
  <section class="search-body">
    <section class="search__wrapper">
      <div class="mb-3">
        <router-link to="/lifestyle/hotel">
          <button type="button" class="btn btn-outline-none text-danger">Go Back</button>
        </router-link>
      </div>
      <div class="row">
        <div class="col-lg-12">
          <div class="flight__section">
            <h5 class="avail-text">Hotels</h5>
          </div>
          <div class="row avail-items">
            <div class="col-lg-4 pb-5" v-for="hotel in hotelList" :key="hotel.hotelId">
              <router-link :to="{ name: 'hotels', params: { id: hotel.hotelId }  }">
                <img :src="hotel.thumbnail" width="100%" height="180px" alt="hotel-img">
                <div class="hotel-info">
                  <p class="hotel-name">{{ hotel.name}} </p>
                  <p class="hotel-address">{{ hotel.hotelAddress }}</p>
                  <div class="d-flex justify-content-between align-items-center mt-2">
                    <div class="d-flex align-items-center">
                      <p class="hotel-rating-count">{{hotel.serviceRating}}/5</p>
                      <p class="hotel-rating pl-2">Excellent</p>
                    </div>
                    <p>{{hotel.serviceRating}}</p>
                  </div>
                </div>
                <div class="price-section">
                  <p class="price">{{ hotel.roomGroupDetailModel.totalNightlyRoomGroupPrice.amount }} <span class="sub-price">Per night per room</span></p>
                  <div class="d-flex justify-content-between align-items-center">
                    <div>
                      <p class="price-per">N25,726 for 1 night 2 room(s)</p>
                      <p class="text-taxes">Includes taxes & fees</p>
                    </div>
                    <button type="button" class="btn btn-danger btn-sm">Book Now</button>
                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
  import { mapState } from 'vuex';
  import moment from 'moment';
  export default {
    filters: {
      moment: function (date) {
        return moment(date).format('HH:MM');
      }
    },
    data:()=>({
    }),
    computed:{
      ...mapState('hotel', ['listOfHotels']),
      hotelList () {
        return this.listOfHotels ? this.listOfHotels.hotelList : this.listOfHotels.hotelList;
      }
    },
    mounted () {
      if (this.listOfHotels.length < 1) {
        this.$router.push('/lifestyle/hotel');
      }
    }
  };
</script>

<style scoped>
hr {
  margin: 0;
  padding: 0;
}
.set-height {
  height: 210px !important;
}
.search-body {
  height: 100%;
  padding: 0 30px;
  margin: 0;
  background-color: #EAF0F3;
}
.search__wrapper {
  padding: 40px 0px
}
.filter__section {
  background-color: #fff;
  padding: 20px;
  margin-bottom: 20px;
  height: 500px;
}
.filter__header {
  background-color: #fff;
  margin-bottom: 20px;
  height: 500px;
}
.flight__check {
  background-color: #fff;
  margin-bottom: 20px;
  height: 100%;
  border-radius: 7px;
}
.filter__section--header {
  padding: 30px 20px;
}
.filter__section--header h5 {
  letter-spacing: 0px;
  color: #1F1F1F;
  opacity: 1;
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 0;
}
.clear-all-text {
  letter-spacing: 0px;
  color: #E41613;
  opacity: 1;
  font-size: 13px;
  font-weight: bold;
  margin-bottom: 0px;
}
.btn-apply {
  padding: 3px 26px !important;
}
.flight__section {
  background-color: #fff;
  padding: 20px;
  margin-bottom: 20px;
}
.avail-items {
  height: 600px;
  overflow: scroll;
}
.avail-items .col-lg-4 img{
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
}
.avail-text {
  letter-spacing: 0px;
  color: #232949;
  opacity: 1;
  font-size: 15px;
  font-weight: 800;
  margin-bottom: 0;
}
.last-side {
  background:#F4FAFE;
  width: 135px;
  height: 100%;
  border-top-right-radius: 7px;
  border-bottom-right-radius: 7px;
}
.last-side-header {
  padding: 8px;
  background: #23384D;
  color: #fff;
  text-align: center;
  border-top-right-radius: 7px;
}
.last-side-header p {
  letter-spacing: 0px;
  color: #fff;
  opacity: 1;
  font-size: 12px;
  font-weight: 500;
  margin-bottom: 0;
}
.px-3 p {
  margin-bottom: 0;
  letter-spacing: 0px;
  color: #6D8494;
  opacity: 1;
  font-size: 11px;
  font-weight: normal;
}
.px-3 h5 {
  letter-spacing: 0px;
  color: #1F1F1F;
  opacity: 1;
  font-size: 14px;
  font-weight: bold;
}
.px-3 h6 {
  letter-spacing: 0px;
  color: #6D8494;
  opacity: 1;
  font-size: 14px;
  font-weight: normal;
}
.pay-full {
  letter-spacing: 0px;
  color: #E41613 !important;
  opacity: 1;
  font-size: 11px;
  font-weight: 400;
  margin-bottom: 0;
}
.amount {
  letter-spacing: 0px;
  color: #1F1F1F;
  opacity: 1;
  font-size: 21px;
  font-weight: bold;
}
.hotel-info {
  padding: 10px 20px 0px 20px;
  background: #fff;
}
.hotel-info .hotel-name {
  letter-spacing: 0px;
  color: #1F1F1F;
  opacity: 1;
  font-size: 15px;
  font-weight: 500;
  margin-bottom: 0;
}
.hotel-address {
  letter-spacing: 0px;
  color: #6D8494;
  opacity: 1;
  font-size: 13px;
  font-weight: normal;
  margin-bottom: 0;
}
.hotel-rating-count {
  background: #F58220;
  border-radius: 5px;
  padding: 7px;
  color: #fff;
  text-align: center;
  width: 40px;
  letter-spacing: 0;
  font-size: 12px;
}
.hotel-rating {
  font-size: 13px;
  color: #223344;
  letter-spacing: 0;
}
.price-section {
  padding:10px 20px;
  background: #F7FBFF;
  border-bottom-right-radius: 8px;
  border-bottom-left-radius: 8px;
}
.price {
  color: #F58220;
  letter-spacing: 0;
  font-size: 21px;
  font-weight: 600;
  margin: 0px 0px 5px 0px;
}
.sub-price {
  font-size: 14px;
  font-weight: normal;
}
.price-per {
  font-weight: bold;
  font-size: 14px;
  color: #6D8494;
  letter-spacing: 0;
  margin: 0px ;
  width: 150px;
}
.text-taxes {
  font-size: 13px;
  color: #6D8494;
  font-weight: normal;
  letter-spacing: 0;
}
</style>